import script from "./FileImport.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileImport.vue?vue&type=script&setup=true&lang=ts"

import "./FileImport.vue?vue&type=style&index=0&id=22adc90c&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Web.API\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22adc90c"]])

export default __exports__